// The Wins reel's ring geometry, from the design mock: cards sit STEP degrees apart on a ring of radius
// R, blur once they are more than 0.4 of a step from the focus, and fade out between 2.2 and 2.8 steps.
// Import-free so it can be unit-tested; `WinsReel` writes the result straight to each slot's style.

export const REEL_STEP_DEG = 36;
export const REEL_RADIUS_PX = 600;

/** The shortest signed distance from the focus to a card, on a ring of `count` cards. */
export function wrapOffset(d: number, count: number): number {
  if (count <= 2) return d;
  let w = ((d % count) + count) % count;
  if (w > count / 2) w -= count;
  return w;
}

export function reelPlacement(d: number): { transform: string; filter: string; opacity: string; zIndex: string } {
  const ad = Math.abs(d);
  const th = (d * REEL_STEP_DEG * Math.PI) / 180;
  const x = (Math.sin(th) * REEL_RADIUS_PX).toFixed(1);
  const z = ((Math.cos(th) - 1) * REEL_RADIUS_PX).toFixed(1);
  return {
    transform: `translate(-50%,-50%) translate3d(${x}px,0,${z}px) rotateY(${(d * REEL_STEP_DEG).toFixed(2)}deg)`,
    filter: ad < 0.4 ? 'none' : `blur(${Math.min(7, (ad - 0.35) * 3.4).toFixed(2)}px)`,
    opacity: ad > 2.8 ? '0' : ad > 2.2 ? ((2.8 - ad) / 0.6).toFixed(3) : '1',
    zIndex: String(1000 - Math.round(ad * 100)),
  };
}
